export const languages = ['fr','en'];

export const defaultLang = 'fr';

export function txt(key, vars){

    const  k = key.replaceAll('-', '').replaceAll('_', '');

    const translation = translations[k];

    if(!translation){
        console.warn(`No translation found for ${key}`);
        return '';
    } 

    const lang = getLang();

    let text = (translation[lang] || translation[defaultLang]) || '';

    if(vars) text = replaceVars(text, vars);

    return text;
}

export function getLang(){

    let lang = navigator.language || defaultLang;

    lang = lang.toString().substring(0, 2).toLowerCase();

    return languages.includes(lang) ? lang : defaultLang;
}

export function setupLang(){

    document.documentElement.lang = getLang();
}

export function replaceVars(text, vars) {

    return text.replace(/{(\w+)}/g, (match, key) => {
        return key in vars ? vars[key] : match;
    });
}


const translations = {
    healthSector: {
        fr: `Filière de santé`,
        en: `Health Sector`
    },
    dentaire: {
        fr: `Dentaire`,
        en: `Dental`
    },
    infirmiere: {
        fr: `Soins Infirmiers`,
        en: `Nursing Care`
    },
    kine: {
        fr: `Kinésithérapie`,
        en: `Physiotherapy`
    },
    medecine: {
        fr: `Médecine Générale`,
        en: `General Medicine`
    },
    pharma: {
        fr: `Pharmacie`,
        en: `Pharmacy`
    },
    santementale: {
        fr: `Santé Mentale`,
        en: `Mental Health`
    },
    nonsoignant: {
        fr: `Non professionnel de santé`,
        en: `Non-healthcare professional`
    },
    dentaireHashtag: {
        fr: `#Dentaire`,
        en: `#Dental`
    },
    infirmiereHashtag: {
        fr: `#SoinsInfirmiers`,
        en: `#NursingCare`
    },
    kineHashtag: {
        fr: `#Kinésithérapie`,
        en: `#Physiotherapy`
    },
    medecineHashtag: {
        fr: `#MédecineGénérale`,
        en: `#GeneralMedecine`
    },
    pharmaHashtag: {
        fr: `#Pharmacie`,
        en: `#Pharmacy`
    },
    santementaleHashtag: {
        fr: `#SantéMentale`,
        en: `#MentalHealth`
    },
    nonsoignantHashtag: {
        fr: `#NonSoignant`,
        en: `#NonHealthcare`
    },
    loginTitle: {
        fr: `Connexion à LearnyLib`,
        en: `Sign in to LearnyLib`,
    },
    noAccountPrompt: {
        fr: `Vous n'avez pas encore de compte ?`,
        en: `Don't have an account yet?`,
    },
    signUp: {
        fr: `Inscrivez-vous`,
        en: `Sign up`,
    },
    passwordResetSuccess: {
        fr: `Votre mot de passe a été réinitialisé avec succès !`,
        en: `Your password has been successfully reset!`,
    },
    loginError: {
        fr: `Vos identifiants sont erronés.`,
        en: `Your login credentials are incorrect.`,
    },
    emailLabel: {
        fr: `Identifiant (email)`,
        en: `Username (email)`,
    },
    forgotPassword: {
        fr: `Mot de passe oublié ?`,
        en: `Forgot your password?`,
    },
    signIn: {
        fr: `Se connecter`,
        en: `Sign In`,
    },
    accountAffiliationTitle: {
        fr: `Affiliation de votre compte`,
        en: `Your Account Affiliation`,
    },
    sponsorSuccess: {
        fr: `{name} est désormais votre parrain LearnyLib !`,
        en: `{name} is now your LearnyLib sponsor!`,
    },
    sponsorErrorOwnAccount: {
        fr: `Vous ne pouvez pas parrainer votre propre compte LearnyLib.`,
        en: `You cannot sponsor your own LearnyLib account.`,
    },
    sponsorErrorDeletedAccount: {
        fr: `Le compte LearnyLib de votre parrain a été supprimé.`,
        en: `Your sponsor's LearnyLib account has been deleted.`,
    },
    sponsorErrorGeneric: {
        fr: `Une erreur s'est produite. L'affiliation de votre compte n'a pas pu être enregistrée.`,
        en: `An error occurred. Your account affiliation could not be recorded.`,
    },
    returnToHome: {
        fr: `Retour à l'accueil`,
        en: `Return to Home`,
    },
    sponsoredPurchases: {
        fr: `achats parrainés`,
        en: `sponsored purchases`
    },
    currencySymbol: {
        fr: `€`,
        en: `€`
    },
    welcomeToLearnyLib: {
        fr: `Bienvenue sur LearnyLib !`,
        en: `Welcome to LearnyLib!`
    },
    noLearnyLibAccountPrompt: {
        fr: `Vous n'avez pas encore de compte LearnyLib ?`,
        en: `Don't have a LearnyLib account yet?`
    },
    alreadyLearnyLibMember: {
        fr: `Vous êtes déjà membre LearnyLib ?`,
        en: `Already a LearnyLib member?`
    },
    accountDeletion: {
        fr: `Suppression du compte`,
        en: `Account Deletion`
    },
    irreversibleOperationWarning: {
        fr: `Cette opération est irréversible.`,
        en: `This operation is irreversible.`
    },
    confirmAccountDeletion: {
        fr: `Veuillez confirmer la suppression de votre compte en entrant votre mot de passe.`,
        en: `Please confirm the deletion of your account by entering your password.`
    },
    incorrectPasswordError: {
        fr: `Mot de passe erroné`,
        en: `Incorrect Password`
    },
    cancel: {
        fr: `Annuler`,
        en: `Cancel`
    },
    deleteAccount: {
        fr: `Supprimer le compte`,
        en: `Delete Account`
    },
    forgotPasswordTitle: {
        fr: `Mot de passe oublié`,
        en: `Forgot Password`
    },
    resetPasswordInstruction: {
        fr: `Afin de réinitialiser votre mot de passe, veuillez entrer l'adresse email de votre compte LearnyLib.`,
        en: `To reset your password, please enter the email address of your LearnyLib account.`
    },
    resetPasswordEmailSent: {
        fr: `Nous vous enverrons un mail contenant un lien permettant de réinitialiser votre mot de passe.`,
        en: `We will send you an email with a link to reset your password.`
    },
    accountEmailAddress: {
        fr: `Adresse email du compte`,
        en: `Account Email Address`
    },
    noAccountForEmailError: {
        fr: `Aucun compte LearnyLib ne correspond à cette adresse`,
        en: `No LearnyLib account matches this address`
    },
    send: {
        fr: `Envoyer`,
        en: `Send`
    },
    emailSentTitle: {
        fr: `Email envoyé !`,
        en: `Email Sent!`
    },
    resetPasswordSuccessMessage: {
        fr: `Vous avez reçu un email contenant un lien permettant de réinitialiser votre mot de passe.`,
        en: `You have received an email with a link to reset your password.`
    },
    checkSpamReminder: {
        fr: `Vous n'avez rien reçu ? Pensez à vérifier vos spams 😉`,
        en: `Didn't receive anything? Remember to check your spam 😉`
    },
    stillNoEmailMessage: {
        fr: `Toujours rien ? 🤨 Contactez-nous au `,
        en: `Still nothing? 🤨 Contact us at `
    },
    contactPhoneNumber: {
        fr: `05 54 54 77 71`,
        en: `+33 554 547 771`
    },
    lastName: {
        fr: `Nom`,
        en: `Last Name`
    },
    firstName: {
        fr: `Prénom`,
        en: `First Name`
    },
    email: {
        fr: `Email`,
        en: `Email`
    },
    password: {
        fr: `Mot de passe`,
        en: `Password`
    },
    emailRequirements: {
        fr: `Doit contenir au moins une majuscule, un chiffre et un caractère spécial`,
        en: `Must contain at least one uppercase letter, one digit, and one special character`
    },
    passwordRequirements: {
        fr: `Doit contenir au moins une majuscule, un chiffre et un caractère spécial`,
        en: `Must contain at least one uppercase letter, one digit, and one special character`
    },
    emailAlreadyUsedError: {
        fr: `Cette adresse email est déjà utilisée.`,
        en: `This email address is already in use.`
    },
    invalidPhoneError: {
        fr: `Ce numéro n'est pas valide`,
        en: `This phone number is not valid`
    },
    invalidEmailError: {
        fr: `Cet email n'est pas valide`,
        en: `This email is not valid`
    },
    studentFileRequired: {
        fr: `Vous devez importer votre justificatif étudiant`,
        en: `You must upload your student proof`
    },
    newsletterOptIn: {
        fr: `Je souhaite être informé de la sortie de nouvelles formations`,
        en: `I wish to be informed about new courses release`
    },
    changesSavedSuccess: {
        fr: `Vos modifications ont bien été enregistrées.`,
        en: `Your changes have been successfully saved.`
    },
    generalError: {
        fr: `Une erreur s'est produite. Veuillez vérifier vos informations.`,
        en: `An error occurred. Please check your information.`
    },
    logOut: {
        fr: `Se déconnecter`,
        en: `Log Out`
    },
    passwordValidationMessage: {
        fr: `Le mot de passe doit contenir au moins une majuscule, un chiffre, et un caractère spécial.`,
        en: `Password must contain at least one uppercase letter, one digit, and one special character.`
    },
    phoneValidationMessage: {
        fr: `Ce numéro n'est pas valide`,
        en: `This phone number is not valid`
    },
    emailValidationMessage: {
        fr: `Cet email n'est pas valide`,
        en: `This email is not valid`
    },
    verificationCodeInvalid: {
        fr: `Ce code n'est pas valide`,
        en: `This code is not valid`
    },
    termsAcceptanceRequired: {
        fr: `Vous devez accepter les conditions générales de ventes`,
        en: `You must accept the terms and conditions`
    },
    generalApiErrorMessage: {
        fr: `Une erreur s'est produite. Veuillez vérifier vos informations et réessayer.`,
        en: `An error has occurred. Please check your information and try again.`
    },
    invalidEmailAddressError: {
        fr: `Cette adresse email est invalide`,
        en: `This email address is invalid`
    },
    invalidFileErrorMessage: {
        fr: `Ce fichier n'est pas valide`,
        en: `This file is not valid`
    },
    createYourAccount: {
        fr: `Créez votre compte`,
        en: `Create Your Account`
    },
    alreadyHaveAccount: {
        fr: `Vous avez déjà un compte ?`,
        en: `Already have an account?`
    },
    logIn: {
        fr: `Connectez-vous`,
        en: `Log In`
    },
    previous: {
        fr: `Précédent`,
        en: `Previous`
    },
    confirm: {
        fr: `Confirmer`,
        en: `Confirm`
    },
    continue: {
        fr: `Continuer`,
        en: `Continue`
    },
    passwordRequirementMessage: {
        fr: `Le mot de passe doit contenir au moins une majuscule, un chiffre et un caractère spécial.`,
        en: `The password must contain at least one uppercase letter, one digit, and one special character.`
    },
    passwordMismatchMessage: {
        fr: `Les mots de passes ne sont pas identiques`,
        en: `The passwords do not match`
    },
    resetYourPassword: {
        fr: `Réinitialisez votre mot de passe`,
        en: `Reset Your Password`
    },
    newPassword: {
        fr: `Nouveau mot de passe`,
        en: `New Password`
    },
    confirmPassword: {
        fr: `Confirmez le mot de passe`,
        en: `Confirm Password`
    },
    validate: {
        fr: `Valider`,
        en: `Validate`
    },
    referralLinkTitle: {
        fr: `Lien de parrainage`,
        en: `Referral Link`
    },
    referralLinkDescription: {
        fr: `Copiez le lien ci-dessous et partagez le autour de vous. Tous les deux achats que vous parrainez, nous vous offrons la formation LearnyLib de votre choix parmi le catalogue de formations cliniques. À vous de jouer !`,
        en: `Copy the link below and share it around. For every two purchases you sponsor, we offer you the LearnyLib course of your choice. It's your turn to play!`
    },
    myReferrals: {
        fr: `Mes filleuls`,
        en: `My Referrals`
    },
    noReferralsYet: {
        fr: `Vous ne parrainez personne pour l'instant.`,
        en: `You are not sponsoring anyone at the moment.`
    },
    referralOnlyPaidInsights: {
        fr: `Seules les inscriptions PAYANTES créditent votre compte de parrainage. Les formations offertes ne sont pas prises en compte.`,
        en: `Only PAID registrations credit your referral account. Free courses are not counted.`
    },
    mySponsor: {
        fr: `Mon parrain`,
        en: `My Sponsor`
    },
    noSponsor: {
        fr: `Vous n'avez pas de parrain LearnyLib.`,
        en: `You do not have a LearnyLib sponsor.`
    },
    sponsoredBy: {
        fr: `Votre compte LearnyLib est parrainé par {name}.`,
        en: `Your LearnyLib account is sponsored by {name}.`
    },
    linkCopiedMessage: {
        fr: `Le lien a bien été copié`,
        en: `The link has been copied successfully`
    },
    generateMyLink: {
        fr: `Générer mon lien`,
        en: `Generate My Link`
    },
    howDidYouHearAboutUs: {
        fr: `Comment nous avez-vous connu ?`,
        en: `How did you hear about us?`
    },
    specify: {
        fr: `Précisez`,
        en: `Specify`
    },
    acceptTerms: {
        fr: `J'accepte les `,
        en: `I accept the `
    },
    termsAndConditions: {
        fr: `Conditions Générales de Ventes`,
        en: `Terms and Conditions`
    },
    accountCreatedOn: {
        fr: `Compte créé le `,
        en: `Account created on `
    },
    myProfile: {
        fr: `Mon profil`,
        en: `My Profile`
    },
    sponsorship: {
        fr: `Parrainage`,
        en: `Sponsorship`
    },
    verificationCodeSent: {
        fr: `Pour des raisons de sécurité, un code de vérification à 4 chiffres vous a été envoyé par email.`,
        en: `For security reasons, a 4-digit verification code has been sent to your email.`
    },
    enterVerificationCodeBelow: {
        fr: `Veuillez le renseigner ci-dessous :`,
        en: `Please enter it below:`
    },
    verificationCode: {
        fr: `Code de vérification`,
        en: `Verification Code`
    },
    invalidCodeMessage: {
        fr: `Ce code n'est pas valide`,
        en: `This code is not valid`
    },
    didNotReceiveEmail: {
        fr: `Vous n'avez pas reçu d'email ? Veuillez patienter quelques instants et pensez à vérifier vos SPAMS 😉`,
        en: `Didn't receive an email? Please wait a few moments and remember to check your SPAM 😉`
    },
    studentProof: {
        fr: `Justificatif étudiant`,
        en: `Student Proof`
    },
    importStudentProof: {
        fr: `Importer un justificatif étudiant (JPG, PNG ou PDF)`,
        en: `Import student proof  (JPG, PNG or PDF)`
    },
    acceptedFormats: {
        fr: `Formats acceptés : JPG, PNG, PDF`,
        en: `Accepted formats: JPG, PNG, PDF`
    },
    phone: {
        fr: `Téléphone`,
        en: `Phone`
    },
    createdAt: {
        fr: `Créé le`,
        en: `Created On`
    },
    file: {
        fr: `Fiche`,
        en: `Profile`
    },
    courses: {
        fr: `Formations`,
        en: `Courses`
    },
    completion: {
        fr: `Complétion %`,
        en: `Completion %`
    },
    company: {
        fr: `Entreprise`,
        en: `Company`
    },
    companySpaceTitle: {
        fr: `Espace Entreprise`,
        en: `Company Space`
    },
    enrollments: {
        fr: `Inscriptions`,
        en: `Enrollments`
    },
    registeredOn: {
        fr: `Inscrit le`,
        en: `Registered On`
    },
    course: {
        fr: `Formation`,
        en: `Course`
    },
    avatar: {
        fr: `Avatar`,
        en: `Avatar`
    },
    user: {
        fr: `Utilisateur`,
        en: `User`
    },
    type: {
        fr: `Type`,
        en: `Type`
    },
    amount: {
        fr: `Montant €`,
        en: `Amount €`
    },
    address: {
        fr: `Adresse`,
        en: `Address`
    },
    zipCode: {
        fr: `Code postal`,
        en: `Zip Code`
    },
    city: {
        fr: `Ville`,
        en: `City`
    },
    country: {
        fr: `Pays`,
        en: `Country`
    },
    users: {
        fr: `Utilisateurs`,
        en: `Users`
    },
    averageCompletion: {
        fr: `Complétion moy.`,
        en: `Avg. Completion`
    },
    profile: {
        fr: `Profil`,
        en: `Profile`
    },
    sector: {
        fr: `Filière`,
        en: `Sector`
    },
    sectorPoint: {
        fr: `Filière :`,
        en: `Sector:`
    },
    companyPoint: {
        fr: `Entreprise :`,
        en: `Company:`
    },
    statusPoint: {
        fr: `Statut :`,
        en: `Status:`
    },
    rppsPoint: {
        fr: `RPPS :`,
        en: `RPPS:`
    },
    notProvided: {
        fr: `Non renseigné`,
        en: `Not Provided`
    },
    addressUnknown: {
        fr: `Adresse inconnue`,
        en: `Address Unknown`
    },
    zipUnknown: {
        fr: `Code postal inconnu`,
        en: `Zip Code Unknown`
    },
    cityUnknown: {
        fr: `Ville inconnue`,
        en: `City Unknown`
    },
    contact: {
        fr: `Contact`,
        en: `Contact`
    },
    training: {
        fr: `Formation`,
        en: `Training`,
    },
    date: {
        fr: `Date`,
        en: `Date`,
    },
    cost: {
        fr: `Coût`,
        en: `Cost`,
    },
    dpc: {
        fr: `DPC`,
        en: `DPC`,
    },
    documents: {
        fr: `Documents`,
        en: `Documents`,
    },
    userCreatedSuccess: {
        fr: `L'utilisateur a été créé avec succès`,
        en: `User has been created successfully`
    },
    userModifiedSuccess: {
        fr: `L'utilisateur a été modifié avec succès`,
        en: `User has been modified successfully`
    },
    emailAlreadyUsed: {
        fr: `Cette adresse email est déjà utilisée`,
        en: `This email address is already in use`
    },
    submitErrorOccurred: {
        fr: `Une erreur s'est produite. Vérifiez les informations et réessayez.`,
        en: `An error occurred. Please check the information and try again.`
    },
    errorOccurred: {
        fr: `Une erreur s'est produite.`,
        en: `An error occurred.`
    },
    invalidPhoneNumber: {
        fr: `Ce numéro n'est pas valide`,
        en: `This phone number is not valid`
    },
    invalidEmail: {
        fr: `Cet email n'est pas valide`,
        en: `This email is not valid`
    },
    invalidPasswordRequirements: {
        fr: `Le mot de passe doit contenir au moins une majuscule, un chiffre et un caractère spécial`,
        en: `The password must contain at least one uppercase letter, a number, and a special character`
    },
    contactLoadError: {
        fr: `Le contact n'a pas pu être chargé`,
        en: `The contact could not be loaded`
    },
    enrollmentsCaption: {
        fr: `Inscription(s)`,
        en: `Enrollment(s)`
    },
    averageCompletionCaption: {
        fr: `Complétion moy.`,
        en: `Avg. Completion`
    },
    confirmUserDeletion: {
        fr: `Êtes-vous sûr de vouloir supprimer cet utilisateur ?`,
        en: `Are you sure you want to delete this user?`
    },
    userDeletedMessage: {
        fr: `L'utilisateur {name} a été supprimé`,
        en: `User {name} has been deleted`
    },
    userDeletionErrorMessage: {
        fr: `Une erreur s'est produite, l'utilisateur {name} n'a pas été supprimé.`,
        en: `An error occurred, user {name} was not deleted.`
    },
    program: {
        fr: `Programme`,
        en: `Program`
    },
    copyEnrollmentLinkMessage: {
        fr: `Le lien d'inscription à la formation a été copié`,
        en: `The enrollment link to the course has been copied`
    },
    shareButton: {
        fr: `Partager`,
        en: `Share`
    },
    trainingCatalogTitle: {
        fr: `Catalogue de formations`,
        en: `Training Catalog`
    },
    showMoreButton: {
        fr: `Afficher plus`,
        en: `Show More`
    },
    chargeLabel: {
        fr: `Prise en charge`,
        en: `Coverage`
    },
    productedBy: {
        fr: `Produit par`,
        en: `Producted by`
    },
    all: {
        fr: `Toutes`,
        en: `All`
    },
    all2: {
        fr: `Tous`,
        en: `All`
    },
    integratedProgram: {
        fr: `Programme Intégré DPC`,
        en: `Programme Intégré DPC`
    },
    offered: {
        fr: `Offert`,
        en: `Offered`
    },
    thematicLabel: {
        fr: `Thématique`,
        en: `Theme`
    },
    sortByLabel: {
        fr: `Trier par`,
        en: `Sort by`
    },
    rating: {
        fr: `Note`,
        en: `Rating`
    },
    title: {
        fr: `Titre`,
        en: `Title`
    },
    addButton: {
        fr: `Ajouter`,
        en: `Add`
    },
    enrollButton: {
        fr: `S'inscrire`,
        en: `Enroll`
    },
    welcomeMessage: {
        fr: `Bienvenue sur LearnyLib ! Vous n'êtes inscrit à aucun cours pour l'instant.`,
        en: `Welcome to LearnyLib! You are not enrolled in any courses yet.`
    },
    consultCatalogueMessage: {
        fr: `Consultez le catalogue`,
        en: `Check out the catalogue`
    },
    courseAccessMessage: {
        fr: `Votre formation sera accessible à partir du {date}`,
        en: `Your course will be accessible starting {date}`
    },
    myCoursesTitle: {
        fr: `Mes formations`,
        en: `My Courses`
    },
    coursesLoadError: {
        fr: `Une erreur s'est produite, vos formations n'ont pas pu être chargées.`,
        en: `An error occurred, your courses could not be loaded.`
    },
    searchInMyCourses: {
        fr: `Rechercher dans mes formations`,
        en: `Search among my courses`
    },
    viewCourseButton: {
        fr: `VOIR LE COURS`,
        en: `VIEW COURSE`
    },
    recommendedForYou: {
        fr: `Recommandé pour vous`,
        en: `Recommended for You`
    },
    yourRegistration: {
        fr: `Votre inscription`,
        en: `Your Registration`
    },
    errorOccurredRetryLater: {
        fr: `Une erreur s'est produite. Veuillez réessayer ultérieurement.`,
        en: `An error occurred. Please try again later.`
    },
    alreadyEnrolled: {
        fr: `Vous êtes déjà inscrit à cette formation`,
        en: `You are already enrolled in this course`
    },
    chooseEnrollmentMode: {
        fr: `Choisissez votre mode d'inscription :`,
        en: `Choose your enrollment mode:`
    },
    noEnrollmentModeAvailable: {
        fr: `Aucun mode d'inscription n'est disponible.`,
        en: `No enrollment mode available.`
    },
    professionalFeesTitle: {
        fr: `Frais professionnels : accès immédiat sans formalités administratives`,
        en: `Professional Fees: Immediate access without administrative formalities`
    },
    availableRegistrationModes: {
        fr: `Les modes d'inscriptions disponibles dépendent des informations professionnelles renseignées dans votre compte utilisateur. En cas de doute, veuillez vérifier`,
        en: `The available registration modes depend on the professional information provided in your user account. In case of doubt, please verify`
    },
    yourInformation: {
        fr: `vos informations`,
        en: `your information`
    },
    selectThisOption: {
        fr: `Choisir cette option`,
        en: `Select this option`
    },
    search: {
        fr: `Rechercher`,
        en: `Search`
    },
    save: {
        fr: `Enregistrer`,
        en: `Save`
    },
    changePassword: {
        fr: `Modifier le mot de passe`,
        en: `Change password`
    },
    phoneExample: {
        fr: `Exemple : +33 6 00 11 22 33`,
        en: `Example: +1 555 123 4567`
    },
    createUser: {
        fr: `Créer un utilisateur`,
        en: `Create a user`
    },
    createAnAccount: {
        fr: `Créer un compte`,
        en: `Create an account`,
    },
    updateAnAccount: {
        fr: `Modifier un compte`,
        en: `Update an account`,
    },
    userCompanyAffiliation: {
        fr: `L'utilisateur sera rattaché à l'entreprise`,
        en: `The user will be affiliated with the company`,
    },
    contactLoadingError: {
        fr: `Le contact n'a pas pu être chargé`,
        en: `Failed to load the contact`,
    },
    needHelp: {
        fr: `Besoin d'aide pour vous inscrire ?`,
        en: `Need help with your registration?`,
    },
    contactUs: {
        fr: `Contactez-nous au`,
        en: `Contact us at`,
    },
    dashboard: {
        fr: `Tableau de bord`,
        en: `Dashboard`
    },
    teacher: {
        fr: `Formateur`,
        en: `Teacher`
    },
    catalogue: {
        fr: `Catalogue`,
        en: `Catalog`
    },
    reviews: {
        fr: `Avis`,
        en: `Reviews`
    },
    community: {
        fr: `Communauté`,
        en: `Community`
    },
    backOffice: {
        fr: `Back office`,
        en: `Back Office`
    },
    crm: {
        fr: `CRM`,
        en: `CRM`
    },
    marketing: {
        fr: `Marketing`,
        en: `Marketing`
    },
    myAccount: {
        fr: `Mon compte`,
        en: `My Account`
    },
    logout: {
        fr: `Se déconnecter`,
        en: `Log Out`
    },
    elearning: {
        fr: `E-learning`,
        en: `E-learning`
    },
    newsFeed: {
        fr: `Fil d'actualité`,
        en: `News Feed`
    },
    myPosts: {
        fr: `Mes posts`,
        en: `My Posts`
    },
    myFavorites: {
        fr: `Mes favoris`,
        en: `My Favorites`
    },
    overview: {
        fr: `Objectifs`,
        en: `Overview`
    },
    plan: {
        fr: `Plan`,
        en: `Curriculum`
    },
    certificate: {
        fr: `Certificat`,
        en: `Certificate`
    },
    design: {
        fr: `Édition`,
        en: `Editing` 
    },
    liberalProfessionalDeduction: {
        fr: `En tant que professionnel libéral, vous pouvez déduire les frais d'inscription de votre déclaration de revenus en tant que frais professionnels.`,
        en: `As a liberal professional, you can deduct registration fees from your income tax return as professional expenses.`
    },
    taxCreditPossibility: {
        fr: `Ces frais peuvent également donner droit à un crédit d'impôt. Pour plus d'informations, consultez votre comptable.`,
        en: `These expenses may also be eligible for a tax credit. For more information, please consult your accountant.`
    },
    freeRegistration: {
        fr: `S'inscrire gratuitement`,
        en: `Register for Free`
    },
    registrationTitle: {
        fr: `Votre inscription`,
        en: `Your Registration`
    },
    registrationSuccessMessage: {
        fr: `Félicitations ! Votre inscription a bien été prise en compte. Vous allez être redirigé sur la page d'accueil.`,
        en: `Congratulations! Your registration has been successfully processed. You will be redirected to the homepage.`
    },
    registrationErrorMessage: {
        fr: `Une erreur s'est produite. Votre inscription n'a pas été prise en compte.`,
        en: `An error occurred. Your registration could not be processed.`
    },
    orderSuccessMessage: {
        fr: `Félicitations ! Votre commande a bien été prise en compte.`,
        en: `Congratulations! Your order has been successfully processed.`
    },
    adfOrigin: {
        fr: `ADF`,
        en: `ADF`
    },
    boucheoreilleOrigin: {
        fr: `Bouche à oreille`,
        en: `Word of mouth`
    },
    courrierOrigin: {
        fr: `Courrier postal`,
        en: `Mail`
    },
    facebookOrigin: {
        fr: `Facebook`,
        en: `Facebook`
    },
    instagramOrigin: {
        fr: `Instagram`,
        en: `Instagram`
    },
    googleOrigin: {
        fr: `Recherche Google`,
        en: `Google search`
    },
    dpcOrigin: {
        fr: `Site du DPC`,
        en: `DPC website`
    },
    umeoOrigin: {
        fr: `Umeo`,
        en: `Umeo`
    },
    autreOrigin: {
        fr: `Autre`,
        en: `Other`
    },
    successCertificate: {
        fr: `Certificat de réussite`,
        en: `Certificate of Achievement`
    },
    modificationsSavedSuccessfully: {
        fr: `Vos modifications ont été enregistrées avec succès`,
        en: `Your modifications have been successfully saved`
    },
    errorCheckForm: {
        fr: `Une erreur s'est produite. Vérifiez le formulaire.`,
        en: `An error occurred. Please check the form.`
    },
    confirmDeleteCourse: {
        fr: `Êtes-vous sûr de vouloir supprimer cette formation ? Cette opération est irréversible.`,
        en: `Are you sure you want to delete this course? This action is irreversible.`
    },
    courseDeletionFailed: {
        fr: `La formation n'a pas pu être supprimée`,
        en: `The course could not be deleted`
    },
    imageTooHeavyOrWrongFormat: {
        fr: `Image trop lourde ou format incorrect`,
        en: `Image too heavy or incorrect format`
    },
    editCourseTitle: {
        fr: `Éditer la formation`,
        en: `Edit Course`
    },
    uniqueId: {
        fr: `Identifiant unique`,
        en: `Unique ID`
    },
    courseName: {
        fr: `Nom de la formation`,
        en: `Course Name`
    },
    courseType: {
        fr: `Type de formation`,
        en: `Type of Course`
    },
    deleteCourse: {
        fr: `Supprimer la formation`,
        en: `Delete Course`
    },
    speakers: {
        fr: `Intervenants`,
        en: `Speakers`
    },
    tutorial: {
        fr: `Tutoriel`,
        en: `Tutorial`
    },
    salesPageUrl: {
        fr: `URL de la page de vente`,
        en: `Sales Page URL`
    },
    basePrice: {
        fr: `Tarif de base`,
        en: `Base Price`
    },
    addThumbnail: {
        fr: `Ajouter une vignette`,
        en: `Add a Thumbnail`
    },
    accessToCommunitySpace: {
        fr: `Accès à l'espace communautaire`,
        en: `Access to Community Space`
    },
    publishCourseInCatalog: {
        fr: `Publier la formation dans le catalogue`,
        en: `Publish Course in Catalog`
    },
    privateCourseForCompany: {
        fr: `Privatiser la formation pour l'entreprise`,
        en: `Private Course for the Company`
    },
    dropImage: {
        fr: `Déposer une image`,
        en: `Drop an Image`
    },
    fileFormatNotAccepted: {
        fr: `Le format du fichier {fileName} n'est pas accepté`,
        en: `The format of the file {fileName} is not accepted`
    },
    fileTooLarge: {
        fr: `Le fichier {fileName} est trop volumineux`,
        en: `The file {fileName} is too large`
    },
    pleaseFinalize: {
        fr: `Veuillez finaliser la`,
        en: `Please finalize the`
    },
    creationLinkText: {
        fr: `création de la formation`,
        en: `course creation`
    },
    editPlanMessage: {
        fr: `avant d'éditer le plan`,
        en: `before editing the plan`
    },
    coursePlanTitle: {
        fr: `Plan de la formation`,
        en: `Curriculum`
    },
    chapterButton: {
        fr: `Chapitre`,
        en: `Chapter`
    },
    viewButton: {
        fr: `Visualiser`,
        en: `View`
    },
    quiz: {
        fr: `Questionnaire`,
        en: `Quiz`
    },
    questionButton: {
        fr: `Question`,
        en: `Question`
    },
    returnToPlanButton: {
        fr: `Retour au plan`,
        en: `Return to Plan`
    },
    dropBackgroundImage: {
        fr: `Déposez une image d'arrière plan`,
        en: `Drop a background image`
    },
    a4FormatInfo: {
        fr: `au format A4 (jpg, jpeg ou png)`,
        en: `in A4 format (jpg, jpeg, or png)`
    },
    positionVariables: {
        fr: `puis positionnez les variables`,
        en: `then position the variables`
    },
    availableVariables: {
        fr: `Variables disponibles`,
        en: `Available variables`
    },
    userFirstName: {
        fr: `Prénom de l'utilisateur`,
        en: `User's first name`
    },
    userLastName: {
        fr: `Nom de l'utilisateur`,
        en: `User's last name`
    },
    courseTitle: {
        fr: `Titre de la formation`,
        en: `Course title`
    },
    issueDate: {
        fr: `Date de délivrance`,
        en: `Issue date`
    },
    certificateNumber: {
        fr: `Numéro du certificat`,
        en: `Certificate number`
    },
    addText: {
        fr: 'Ajoutez un texte',
        en: 'Add some text',
    },
    deleteSelection: {
        fr: `Supprimer la sélection`,
        en: `Delete the selection`,
    },
    orientation: {
        fr: `Orientation`,
        en: `Orientation`,
    },
    landscape: {
        fr: `Paysage`,
        en: `Landscape`,
    },
    portrait: {
        fr: `Portrait`,
        en: `Portrait`,
    },
    test: {
        fr: `Tester`,
        en: `Test`,
    },
    confirmDeleteChapter: {
        fr: `Êtes-vous sûr de vouloir supprimer ce chapitre ?`,
        en: `Are you sure you want to delete this chapter?`,
    },
    confirmDeleteSection: {
        fr: `Êtes-vous sûr de vouloir supprimer ce chapitre ?`,
        en: `Are you sure you want to delete this section?`,
    },
    confirmDeleteChoice: {
        fr: `Êtes-vous sûr de vouloir supprimer ce choix?`,
        en: `Are you sure you want to delete this choice?`,
    },
    confirmDeleteQuestion: {
        fr: `Êtes-vous sûr de vouloir supprimer cette question ?`,
        en: `Are you sure you want to delete this question?`,
    },
    addTitle: {
        fr: `Ajouter un titre`,
        en: `Add a title`,
    },
    chapter: {
        fr: `Chapitre`,
        en: `Chapter`,
    },
    section: {
        fr: `Section`,
        en: `Section`,
    },
    sectionType: {
        fr: `Type de section`,
        en: `Section type`,
    },
    uploadZipFileLabel: {
        fr: `Déposer un fichier .ZIP`,
        en: `Upload a .ZIP file`,
    },
    quizPassMarkLabel: {
        fr: `Score minimum pour valider le Quiz`,
        en: `Minimum Score to Pass the Quiz`,
    },
    editQuizButton: {
        fr: `Éditer le quiz`,
        en: `Edit the Quiz`,
    },
    view: {
        fr: `Vue`,
        en: `View`,
    },
    requiredLabel: {
        fr: `Section bloquante`,
        en: `Blocking Section`,
    },
    incrementCompletionLabel: {
        fr: `Incrémente la complétion`,
        en: `Increment Completion`,
    },
    errorFileMissing: {
        fr: "Ce fichier n'est pas valide.",
        en: "This file is not valid.",
    },
    errorFileExtension: {
        fr: "Cette extension n'est pas acceptée.",
        en: "This extension is not accepted.",
    },
    errorFileType: {
        fr: "Ce format de vidéo n'est pas accepté.",
        en: "This video format is not accepted.",
    },
    errorFileSize: {
        fr: "Cette vidéo est trop lourde.",
        en: "This video is too large.",
    },
    errorVideo: {
        fr: "La vidéo n'a pas pu être créée.",
        en: "The video could not be created.",
    },
    errorUrl: {
        fr: "La vidéo n'a pas pu être chargée.",
        en: "The video could not be loaded.",
    },
    errorUpload: {
        fr: "L'upload de la vidéo a été interrompu.",
        en: "Video upload was interrupted.",
    },
    dropVideo: {
        fr: "Déposer une vidéo",
        en: "Drop a video",
    },
    successVideoUpload: {
        fr: `La vidéo a été uploadée avec succès.`,
        en: `The video has been uploaded successfully.`,
    },
    infoVideoTranscoding: {
        fr: `Vidéo en cours de transcodage...`,
        en: `Video is currently being transcoded...`,
    },
    explanationLabel: {
        fr: `Explication`,
        en: `Explanation`,
    },
    correctToggleLabel: {
        fr: `Réponse correcte`,
        en: `Correct Answer`,
    },
    question: {
        fr: `Question`,
        en: `Question`,
    },
    choice: {
        fr: `Choix`,
        en: `Choice`,
    },
    pictureLabel: {
        fr: `Ajouter une image`,
        en: `Add an image`,
    },
    correctionLabel: {
        fr: `Correction`,
        en: `Correction`,
    },
    videoType: {
        fr: `Vidéo`,
        en: `Video`,
    },
    youtubeType: {
        fr: `YouTube`,
        en: `YouTube`,
    },
    htmlType: {
        fr: `Texte`,
        en: `Text`,
    },
    googleType: {
        fr: `Google Doc`,
        en: `Google Doc`,
    },
    downloadType: {
        fr: `Annexe ZIP`,
        en: `ZIP Attachment`,
    },
    quizType: {
        fr: `Quiz`,
        en: `Quiz`,
    },
    pdfType: {
        fr: `PDF`,
        en: `PDF`,
    },
    reviewType: {
        fr: `Avis`,
        en: `Review`,
    },
    evaluationStartType: {
        fr: `Auto-évaluation initiale`,
        en: `Initial Self-Assessment`,
    },
    evaluationEndType: {
        fr: `Auto-évaluation finale`,
        en: `Final Self-Assessment`,
    },
    auditBeforeType: {
        fr: `EPP : Audit clinique initial`,
        en: `EPP: Initial Clinical Audit`,
    },
    auditAfterType: {
        fr: `EPP : Audit clinique final`,
        en: `EPP: Final Clinical Audit`,
    },
    auditRecoType: {
        fr: `EPP : Recommandations`,
        en: `EPP: Recommendations`,
    },
    improvementsType: {
        fr: `EPP : Actions correctives`,
        en: `EPP: Corrective Actions`,
    },
    participationType: {
        fr: `Attestation de participation DPC`,
        en: `DPC Participation Certificate`,
    },
    viewType: {
        fr: `Vue dynamique`,
        en: `Dynamic View`,
    },
    certificateType: {
        fr: `Certificat de réussite`,
        en: `Certificate of Completion`,
    },
    notionType: {
        fr: `Page Notion`,
        en: `Notion Page`,
    },
    sponsorType: {
        fr: `Parrainage`,
        en: `Share`,
    },
    customType: {
        fr: `HTML custom`,
        en: `Custom HTML`,
    },
    videoMediaLabel: {
        fr: `Identifiant Vimeo`,
        en: `Vimeo ID`,
    },
    customMediaLabel: {
        fr: `Code HTML à insérer dans la balise "body"`,
        en: `HTML code to insert into the body tag`,
    },
    youtubeMediaLabel: {
        fr: `Identifiant YouTube`,
        en: `YouTube ID`,
    },
    googleMediaLabel: {
        fr: `Lien Google`,
        en: `Google Link`,
    },
    errorFileNotPDF: {
        fr: `Le fichier n'est pas au format PDF.`,
        en: `The file is not in PDF format.`,
    },
    errorPDFTooLarge: {
        fr: `Le PDF est trop lourd.`,
        en: `The PDF is too large.`,
    },
    dropPdf: {
        fr: `Déposer un PDF`,
        en: `Upload a PDF`,
    },
    errorFileTypeNotAccepted: {
        fr: `Le format du fichier n'est pas accepté.`,
        en: `The file format is not accepted.`,
    },
    errorFileTooLarge: {
        fr: `Le fichier est trop lourd.`,
        en: `The file is too large.`,
    },
    fileToUpload: {
        fr: `Fichier`,
        en: `File`,
    },
    dropFile: {
        fr: `Déposer un fichier`,
        en: `Upload a file`,
    },
    notEnrolledInCourse: {
        fr: `Vous n'êtes pas inscrit à cette formation`,
        en: `You are not enrolled in this course`,
    },
    takeNotes: {
        fr: `Prendre des notes`,
        en: `Take notes`,
    },
    askQuestion: {
        fr: `Poser une question`,
        en: `Ask a question`,
    },
    courseTab: {
        fr: `Cours`,
        en: `Course`,
    },
    notesTab: {
        fr: `Mes notes`,
        en: `My notes`,
    },
    docsTab: {
        fr: `Documents de la formation`,
        en: `Training documents`,
    },
    eppTab: {
        fr: `Évaluation des pratiques professionnelles`,
        en: `Evaluation of professional practices`,
    },
    fifplTab: {
        fr: `Tutoriel Prise en Charge FIFPL`,
        en: `FIFPL Support Tutorial`,
    },
    forumTab: {
        fr: `Espace communautaire`,
        en: `Community Space`,
    },
    searchTab: {
        fr: `Rechercher dans la formation`,
        en: `Search in the course`,
    },
    errorSavingProgress: {
        fr: "Une erreur s'est produite, la progression n'a pas été enregistrée.",
        en: "An error occurred, the progress was not saved.",
    },
    finish: {
        fr: 'Terminer',
        en: 'Finish',
    },
    finishAndContinue: {
        fr: 'Terminer et continuer',
        en: 'Finish and Continue',
    },
    viewAllCoursesButton: {
        fr: 'Voir toutes nos formations',
        en: 'View all our courses',
    },
    searchButton: {
        fr: 'Rechercher une partie',
        en: 'Search for a section',
    },
    courseTabShort: {
        fr: 'Cours',
        en: 'Course',
    },
    docsTabShort: {
        fr: 'Docs',
        en: 'Docs',
    },
    notesTabShort: {
        fr: 'Notes',
        en: 'Notes',
    },
    timeSpentPoint: {
        fr: 'Temps passé : ',
        en: 'Time spent: ',
    },
    previousSectionTitle: {
        fr: `la section précédente`,
        en: `the previous section`,
    },
    evaluationTitle: {
        fr: `Évaluation {position} des connaissances`,
        en: `{position} knowledge evaluation`,
    },
    startEvaluation: {
        fr: `initiale`,
        en: `Initial` 
    },
    endEvaluation: {
        fr: `finale`,
        en: `Final` 
    },
    evaluationMissing: {
        fr: `Merci de répondre à toutes les questions`,
        en: `Please answer all questions`,
    },
    expertiseQuestion1: {
        fr: `Quelle expertise pensez-vous avoir dans le domaine abordé par cette formation ? Sur une échelle de 0 à 10, 0 étant aucune et 10 étant expert.`,
        en: `What level of expertise do you think you have in the field covered by this training? On a scale of 0 to 10, 0 being none and 10 being an expert.`,
    },

    expertiseQuestion2: {
        fr: `Vous sentez-vous capable de prendre en charge un patient pour ce type de soin ? Sur une échelle de 0 à 10, 0 étant non et 10 étant absolument.`,
        en: `Do you feel capable of caring for a patient for this type of care? On a scale of 0 to 10, 0 being no and 10 being absolutely.`,
    },

    expertiseQuestion3: {
        fr: `Pratiquez-vous régulièrement ce type de soin dans votre activité quotidienne ? Sur une échelle de 0 à 10, 0 étant jamais et 10 étant plusieurs fois par jour.`,
        en: `Do you regularly practice this type of care in your daily activity? On a scale of 0 to 10, 0 being never and 10 being several times a day.`,
    },
    expertiseQuestion4: {
        fr: `Donnez la définition et les objectifs de cette pratique médicale :`,
        en: `Provide the definition and objectives of this medical practice:`,
    },
    certificateInfo: {
        fr: `Votre certificat vous sera délivré lorsque vous aurez complété votre formation à 100%.`,
        en: `Your certificate will be issued to you when you have completed your training at 100%.`,
    },
    congratulationsMessage: {
        fr: `Félicitations ! Vous avez terminé votre formation. Téléchargez maintenant votre certificat de réussite.`,
        en: `Congratulations! You have completed your training. Download your certificate of achievement now.`,
    },
    downloadCertificate: {
        fr: `Télécharger le certificat`,
        en: `Download Certificate`,
    },
    pdfAndAttachmentsTitle: {
        fr: `Fichiers PDF et annexes`,
        en: `PDFs and Attachments`,
    },
    administrativeDocuments: {
        fr: `Documents administratifs`,
        en: `Administrative Documents`,
    },
    noDocumentsToShow: {
        fr: `Aucun document à afficher`,
        en: `No documents to show`,
    },
    download: {
        fr: `Télécharger`,
        en: `Download`
    },
    sectionUnavailable: {
        fr: `Section indisponible`,
        en: `Section unavailable`,
    },
    notesSaveError: {
        fr: `Vos notes n'ont pas pu être enregistrées.`,
        en: `Your notes could not be saved.`,
    },
    myNotes: {
        fr: `Notes`,
        en: `Notes`
    },
    noNotesTaken: {
        fr: `Vous n'avez pas pris de notes dans cette formation.`,
        en: `You haven't taken any notes in this course.`,
    },
    downloadAsPDF: {
        fr: `Télécharger au format PDF`,
        en: `Download as PDF`,
    },
    unavailableContent: {
        fr: `Contenu indisponible`,
        en: `Unavailable content`
    },
    questionsAboutCourse: {
        fr: `Questions posées sur la formation :`,
        en: `Questions asked about the course:`,
    },
    postPublishedSuccess: {
        fr: `Votre post a bien été publié sur l'espace communautaire LearnyLib !`,
        en: `Your post has been successfully published on the LearnyLib community space!`,
    },
    backToCourse: {
        fr: `Retour au cours`,
        en: `Back to the course`,
    },
    correctAnswers: {
        fr: `Les bonnes réponses sont `,
        en: `The correct answers are `,
    },
    correctAnswer: {
        fr: `La bonne réponse est `,
        en: `The correct answer is `,
    },
    questionCounter: {
        fr: `QUESTION {index} SUR {count}`,
        en: `QUESTION {index} OF {count}`,
    },
    chooseAllApplicable: {
        fr: `Choisissez TOUTES les réponses applicables.`,
        en: `Choose ALL applicable answers.`,
    },
    correctAnswerText: {
        fr: `Cette réponse est correcte.`,
        en: `This answer is correct.`,
    },
    incorrectAnswerText: {
        fr: `Cette réponse est incorrecte.`,
        en: `This answer is incorrect.`,
    },
    quizCompleteTitle: {
        fr: `Vous avez terminé le Quiz !`,
        en: `You have completed the Quiz!`,
    },
    quizPassMessage: {
        fr: `Vous validez cette section avec un score de {score}%.`,
        en: `You pass this section with a score of {score}%.`,
    },
    quizFailMessage: {
        fr: `Vous avez obtenu un score de {score}%. Ce n'est pas suffisant pour valider cette section.`,
        en: `You scored {score}%. It's not enough to pass this section.`,
    },
    restartButton: {
        fr: `Recommencer`,
        en: `Restart`,
    },
    quizSuccessMessage: {
        fr: `Vous avez terminé le quiz et validé cette section.`,
        en: `You have completed the quiz and passed this section.`,
    },
    reviewSuccessMessage: {
        fr: `Votre avis a bien été enregistré`,
        en: `Your review has been saved successfully`,
    },
    reviewErrorMessage: {
        fr: `Une erreur s'est produite, votre avis n'a pas pu être enregistré`,
        en: `An error occurred, your review could not be saved`,
    },
    invalidRatingMessage: {
        fr: `Veuillez mettre une note comprise entre 1 et 5.`,
        en: `Please rate between 1 and 5.`,
    },
    yourRatingLabel: {
        fr: `Votre appréciation :`,
        en: `Your rating:`,
    },
    yourReviewLabel: {
        fr: `Votre avis :`,
        en: `Your review:`,
    },
    yourSuggestionsLabel: {
        fr: `Vos suggestions :`,
        en: `Your suggestions:`,
    },
    suggestionsQuestion: {
        fr: `Que pouvons-nous faire pour nous améliorer ?`,
        en: `What can we do to improve?`,
    },
    chapterPoint: {
        fr: `Chapitre :`,
        en: `Chapter:`
    },
    searchInputLabel: {
        fr: `Rechercher une section ou un chapitre`,
        en: `Search for a section or chapter`,
    },
    reactTitle: {
        fr: 'Réagir',
        en: 'React',
    },
    commentTitle: {
        fr: 'Commenter',
        en: 'Comment',
    },
    saveTitle: {
        fr: 'Favori',
        en: 'Favorite',
    },
    cancelTitle: {
        fr: 'Annuler',
        en: 'Cancel',
    },
    replyToRecipientLabel: {
        fr: 'Répondre à {name}',
        en: 'Reply to {name}',
    },
    myCommentLabel: {
        fr: 'Mon commentaire',
        en: 'My comment',
    },
    hideCommentsButtonLabel: {
        fr: 'Masquer les commentaires',
        en: 'Hide comments',
    },
    confirmDeleteCommentText: {
        fr: 'Êtes-vous certain de vouloir supprimer ce commentaire ?',
        en: 'Are you sure you want to delete this comment?',
    },
    showTitle: {
        fr: 'Voir',
        en: 'Show',
    },
    editTitle: {
        fr: 'Modifier',
        en: 'Edit',
    },
    deleteTitle: {
        fr: 'Supprimer',
        en: 'Delete',
    },
    searchTitle: {
        fr: 'Rechercher',
        en: 'Search',
    },
    backTitle: {
        fr: 'Retour',
        en: 'Back',
    },
    upTitle: {
        fr: 'Monter',
        en: 'Up',
    },
    downTitle: {
        fr: 'Descendre',
        en: 'Down',
    },
    mailTitle: {
        fr: 'Email',
        en: 'Email',
    },
    moneyTitle: {
        fr: 'Prix',
        en: 'Price',
    },
    downloadTitle: {
        fr: 'Télécharger',
        en: 'Download',
    },
    optionsTitle: {
        fr: 'Options',
        en: 'Options',
    },
    helpTitle: {
        fr: 'Aide',
        en: 'Help',
    },
    closeTitle: {
        fr: 'Fermer',
        en: 'Close',
    },
    learnTitle: {
        fr: 'Apprendre',
        en: 'Learn',
    },
    chatTitle: {
        fr: 'Chat',
        en: 'Chat',
    },
    newPost: {
        fr: 'Nouveau post',
        en: 'New post',
    },
    notFound: {
        fr: 'Publication introuvable',
        en: 'Publication not found',
    },
    postDeleted: {
        fr: 'La publication a été supprimée.',
        en: 'The post has been deleted.',
    },
    edit: {
        fr: 'Éditer',
        en: 'Edit',
    },
    delete: {
        fr: 'Supprimer',
        en: 'Delete',
    },
    bugReport: {
        fr: "Rapport d'anomalie",
        en: 'Bug Report',
    },
    content: {
        fr: "Contenu",
        en: 'Content',
    },
    postNotFound: {
        fr: "Ce post n'existe plus.",
        en: 'This post no longer exists.',
    },
    unauthorizedModification: {
        fr: "Vous ne pouvez pas modifier ce post.",
        en: 'You are not authorized to modify this post.',
    },
    publish: {
        fr: "Publier",
        en: 'Publish',
    },
    postSaveError: {
        fr: "Une erreur s'est produite. Votre post n'a pas pu être enregistré.",
        en: 'An error occurred. Your post could not be saved.',
    },
    postTitle: {
        fr: `Titre du post`,
        en: `Post title`
    },
    addKeywordsLabel: {
        fr: 'Ajouter des mots clés',
        en: 'Add keywords',
    },
    publishAnonymouslyLabel: {
        fr: 'Publier de manière anonyme',
        en: 'Publish anonymously',
    },
    anonymousPost: {
        fr: `Publication anonyme`,
        en: `Anonymous`
    },
    postSuccessMessage: {
        fr: 'Merci pour votre publication ! 😊',
        en: 'Thank you for your post! 😊',
    },
    postSuccessMessage2: {
        fr: ' Le formateur vous répondra sous peu.',
        en: ' The instructor will respond shortly.',
    },
    today: {
        fr: `Aujourd'hui`,
        en: `Today` 
    },
    newPostQuestion: {
        fr: "Nouveau post : Que souhaitez-vous écrire ?",
        en: "New post: What would you like to write?",
    },
    questionOption: {
        fr: "J'ai une question sur le contenu d'une formation ou pour un formateur",
        en: "I have a question about the content of a course or for an instructor",
    },
    experienceOption: {
        fr: "Je partage une expérience",
        en: "I'm sharing an experience",
    },
    platformIssueOption: {
        fr: "J'ai une question ou un problème concernant l'utilisation de la plateforme",
        en: "I have a question or an issue regarding the use of the platform",
    },
    showMore: {
        fr: `Afficher plus`,
        en: `Show more`
    },
    noPostsToDisplay: {
        fr: "Aucune publication à afficher",
        en: "No posts to display",
    },
    likeTitle: {
        fr: "J'approuve",
        en: "I agree",
    },
    helpfulTitle: {
        fr: "Instructif",
        en: "Helpful",
    },
    discordTitle: {
        fr: "En désaccord",
        en: "Disagree",
    },
    confirmDeletePostMessage: {
        fr: "Êtes-vous certain de vouloir supprimer ce post ?",
        en: "Are you sure you want to delete this post?",
    },
    tags: {
        fr: `Mots clés`,
        en: `Tags`
    },
    addPictures: {
        fr: `Ajouter des images`,
        en: `Add pictures`
    },
    fileTypeNotAccepted: {
        fr: `Le format du fichier {name} n'est pas accepté`,
        en: `The file format of {name} is not accepted`
    },
    fileTooHeavy: {
        fr: `Le fichier {name} est trop volumineux`,
        en: `The file {name} is too heavy`
    },
    pinLabel: {
        fr: `Code de vérification à {length} chiffres`,
        en: `Verification code of {length} digits`
    },
    videoLabel: {
        fr: `Vidéo`,
        en: `Video`
    },
    youtubeLabel: {
        fr: `Vidéo`,
        en: `Video`
    },
    htmlLabel: {
        fr: `Texte`,
        en: `Text`
    },
    googleLabel: {
        fr: `Texte`,
        en: `Text`
    },
    downloadLabel: {
        fr: `Annexe`,
        en: `Attachment`
    },
    quizLabel: {
        fr: `Quiz`,
        en: `Quiz`
    },
    pdfLabel: {
        fr: `PDF`,
        en: `PDF`
    },
    reviewLabel: {
        fr: `Avis`,
        en: `Review`
    },
    evaluationstartLabel: {
        fr: `Évaluation`,
        en: `Assessment`
    },
    evaluationendLabel: {
        fr: `Évaluation`,
        en: `Assessment`
    },
    auditbeforeLabel: {
        fr: `Audit`,
        en: `Audit`
    },
    auditafterLabel: {
        fr: `Audit`,
        en: `Audit`
    },
    improvementsLabel: {
        fr: `Audit`,
        en: `Audit`
    },
    participationLabel: {
        fr: `Attestation`,
        en: `Certificate`
    },
    viewLabel: {
        fr: `Texte`,
        en: `Text`
    },
    certificateLabel: {
        fr: `Certificat`,
        en: `Certificate`
    },
    sponsorLabel: {
        fr: `Texte`,
        en: `Text`
    },
    customLabel: {
        fr: `Texte`,
        en: `Text`
    },
    completePreviousSection: {
        fr: `Vous devez terminer la section "{section}" pour débloquer la suite de votre formation.`,
        en: `You must complete the section "{section}" to unlock the next part of your training.`
    },
    hideComments: {
        fr: `Masquer les commentaires`,
        en: `Hide comments`
    },
    comment: {
        fr: `commentaire`,
        en: `comment`
    },
    comments: {
        fr: `commentaires`,
        en: `comments`
    },
    now: {
        fr: `À l'instant`,
        en: `Now`
    },
    oneMinuteAgo: {
        fr: `Il y a 1 minute`,
        en: `1 minute ago`
    },
    oneHourAgo: {
        fr: `Il y a 1 heure`,
        en: `1 hour ago`
    },
    oneMonthAgo: {
        fr: `Il y a 1 mois`,
        en: `1 month ago`
    },
    minutesAgo: {
        fr: `Il y a {n} minutes`,
        en: `{n} minutes ago`
    },
    hoursAgo: {
        fr: `Il y a {n} heures`,
        en: `{n} hours ago`
    },
    daysAgo: {
        fr: `Il y a {n} jours`,
        en: `{n} days ago`
    },
    monthsAgo: {
        fr: `Il y a {n} mois`,
        en: `{n} months ago`
    },
    yearsAgo: {
        fr: `Il y a {n} années`,
        en: `{n} years ago`
    },
    yesterday: {
        fr: `Hier`,
        en: `Yesterday`
    },
    unpublishedWarning: {
        fr: `Dépubliée`,
        en: `Unpublished`
    },
    accessibility: {
        fr: `Accessibilité`,
        en: `Accessibility`
    },
    lifetimeAccess: {
        fr: `Accès à vie en illimité`,
        en: `Unlimited lifetime access`,
    },
    administrativeProcedures: {
        fr: `Accompagnement dans les démarches administratives`,
        en: `Support in administrative procedures`,
    },
    TOTAL: {
        fr: `TOTAL :`,
        en: `TOTAL:`,
    },
    catalog: {
        fr: `Catalogue`,
        en: `Catalog`
    },
    selectFinancing: {
        fr: `Sélectionnez votre mode de financement :`,
        en: `Select your financing method:`,
    },
    selected: {
        fr: `Sélectionné`,
        en: `Selected`
    },
    recommended: {
        fr: `Recommandé`,
        en: `Recommended`,
    },
    offer: {
        fr: `Offerte`,
        en: `Free`,
    },
    free100: {
        fr: `100% gratuit`,
        en: `100% free`,
    },
    withoutCommitment: {
        fr: `Sans engagement`,
        en: `Without commitment`,
    },
    immediateAccess: {
        fr: `Accès immédiat`,
        en: `Immediate access`
    },
    hoursOfTraining: {
        fr: `{n}h de formation`,
        en: `{n} hours of training`
    },
    CONFIRM: {
        fr: `CONFIRMER`,
        en: `CONFIRM`,
    },
    handicap: {
        fr: `Je suis en situation de handicap`,
        en: `I have a disability`
    },
    customEnrollUrl: {
        fr: `URL d'inscription personnalisée`,
        en: `Custom enrollment URL`
    }
}

export default defaultLang;